import { MoneyType } from "../../api/api";
import { showError } from "../utils/errorHandler";
import { arrayContainsDuplicates } from "./utils";

export const moneyType = (
  moneyType: MoneyType,
  moneyTypes: MoneyType[],
  origin?: string
): boolean => {
  if (!moneyTypes.includes(moneyType)) {
    showError("Money type has to be a configured money type", origin);
    return false;
  }

  return true;
};

export const moneyTypes = (
  moneyTypes: MoneyType[],
  origin?: string
): boolean => {
  const VALID_TYPES = [MoneyType.CASH, MoneyType.COINS];

  if (!Array.isArray(moneyTypes)) {
    showError("Money types has to be an array", origin);
    return false;
  } else if (moneyTypes.length < 1) {
    showError("Money types must contain at least one choice", origin);
    return false;
  } else if (!moneyTypes.every(m => VALID_TYPES.includes(m))) {
    showError("Money types can only contain money types", origin);
    return false;
  } else if (arrayContainsDuplicates<MoneyType>(moneyTypes)) {
    showError("Money types cannot contain duplicate values", origin);
    return false;
  } else if (!moneyTypes.includes(MoneyType.CASH)) {
    showError(
      "Money types must include MoneyType.CASH (coins only is currently not supported)",
      origin
    );
    return false;
  }

  return true;
};
